<template>
  <div v-for="surcharge in orderedSurcharges" :key="surcharge.id" class="text-xs">
    <span v-if="surcharge.surchargeType === SurchargeTransactionTypes.PERCENTAGE"
      >+ {{ normalizeDecimal(surcharge.getSurchargePercentage()) }}% toeslag over &euro;
      {{ normalizeDecimal(originalTransaction.getTotalAmount(), { maxDecimalPlaces: 2 }) }} = &euro;
      {{ normalizeDecimal(surcharge.getTotalAmount(), { maxDecimalPlaces: 2 }) }}</span
    >
    <span v-else-if="surcharge.surchargeType === SurchargeTransactionTypes.PER_UNIT"
      >+ &euro; {{ normalizeDecimal(surcharge.surchargePerUnit) }} toeslag per
      {{ originalTransaction.getItem().getUnitName() }} over
      {{ normalizeDecimal(originalTransaction.quantity) }}
      {{ originalTransaction.getItem().getUnitName() }} = &euro;
      {{ normalizeDecimal(surcharge.getTotalAmount(), { maxDecimalPlaces: 2 }) }}</span
    >
    <span v-else
      >+ &euro; {{ normalizeDecimal(surcharge.surchargeFlat) }} toeslag per verstrekking</span
    >
  </div>
</template>

<script setup lang="ts">
import { computed, inject, type ComputedRef } from "vue"
import type { Transaction } from "@/models/transaction.model"
import { SurchargeTransactionTypes } from "@/interfaces/api/transaction.interface"
import { normalizeDecimal } from "@/helper/number-helper"

const props = defineProps<{
  originalTransaction: Transaction
  transactionId: string
}>()

const consolidatedSurcharges = inject<ComputedRef<Map<string, Transaction[]>>>(
  "consolidatedSurcharges",
  computed(() => new Map())
)

// Force consistent order of surcharges
const surchargeTypeOrder: Record<string, number> = {
  [SurchargeTransactionTypes.PERCENTAGE]: 0,
  [SurchargeTransactionTypes.PER_UNIT]: 1,
  [SurchargeTransactionTypes.FLAT]: 2
}

const orderedSurcharges = computed(() => {
  const surcharges = consolidatedSurcharges.value.get(props.transactionId) ?? []
  return [...surcharges].sort(
    (a, b) => surchargeTypeOrder[a.surchargeType!] - surchargeTypeOrder[b.surchargeType!]
  )
})
</script>

<style scoped></style>
